import Vue from 'vue'
import Vuex from 'vuex'

import {home} from './home.module'
Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        $http: null,
        $notify: null,
        $cookies: null,
        $session: null,
        loading: false,
        base_url: process.env.VUE_APP_OLD_API,
        tds_api: process.env.VUE_APP_NEW_API,
        enow_url: process.env.VUE_APP_ENOW,
        eno: process.env.VUE_APP_ENO,
        banner_link: process.env.VUE_APP_BANNER_LINK,
        banner_image: process.env.VUE_APP_BANNER_IMAGE,        
        background_image: process.env.VUE_APP_BACKGROUND_IMAGE,        
        token: '0-TDS-Anonymous-TDS-0',
        anonymous: '0-TDS-Anonymous-TDS-0',
        disableToken: 'd30cf0dc7c82fe59e1a6f791722976',
        remember: false,
        menu_open: false,
        disableLogin: false,
        lang: 'it',
        admin: false,
        user: false
    }, getters: {
        base_url(state) {
            return state.base_url
        }, enow_url(state) {
            return state.enow_url
        }, banner_link(state) {
            return state.banner_link
        }, banner_image(state) {
            return state.banner_image
        }, background_image(state) {
            return state.background_image
        }, loading(state, getters) {
            return getters['races/loading'] || state.loading
        }, eno(state) {
          return state.eno
        },
        url(state) {
            return state.base_url+'/'+state.token+'/'+state.lang+'/';
        }, locale(state) {
            return state.lang
        }, logged(state) {
            if (state.disableLogin) return  true

            return state.token !== state.anonymous
        }, admin(state) {
            return state.token !== state.anonymous && state.admin
        }, token(state) {
            return state.token
        },tds_api(state) {
            return state.tds_api+'/'+state.lang
        }, user_name(state) {
            if (!state.user) return ''
            return  state.user.UserName
        }, user_surname(state) {
            if (!state.user) return ''
            return  state.user.UserSurname
        }, menu_open(state) {
            return state.menu_open
        }, disableLogin(state) {
            return state.disableLogin
        }
    }, mutations: {
        vue(state, vue)
        {
            state.$http = vue.$http
            state.$notify = vue.$notify
            state.$cookies = vue.$cookies
            if (state.disableLogin)
            {
                state.token = state.disableToken
                return true
            }

            let user = sessionStorage.getItem('user')
            if (!user) user = localStorage.getItem('user')
            if (user)
            {
                user = JSON.parse(user)
                state.user = user
                state.token = state.user.Token
                let isAdmin = false
                if (state.user.Type === 3) isAdmin = true
                if (state.user.Type === 10) isAdmin = true
                state.admin = isAdmin
            }
        },loading(state,value)
        {
            state.loading = value
        }, lang(state,value)
        {
            state.lang = value
        },user(state,user)
        {
            state.user = user
            if (user) {
                state.token = user.Token
                let isAdmin = false
                if (user.Type === 3) isAdmin = true
                if (user.Type === 10) isAdmin = true
                state.admin = isAdmin

                if (user.remember)
                    localStorage.setItem('user',JSON.stringify(user))
                else
                    sessionStorage.setItem('user',JSON.stringify(user))
            }
            else
            {
                state.token = state.anonymous
                state.admin = false
                localStorage.removeItem('user')
                sessionStorage.removeItem('user')
            }
        }, menu_open(state,value)
        {
            state.menu_open = value
        }
    }, modules: {
        home
    }
})
